export default __webpack_public_path__ + "static/media/payment-failed.2b15db51.svg";